import { IThemeColor } from '../../theme/IThemeColor';
import { ChangeIndicator } from './ChangeIndicator';

export interface IPctChangeIndicatorProps {
    oldValue: number;
    newValue: number;
    upColor?: IThemeColor;
    downColor?: IThemeColor;
}

export const PctChangeIndicator: React.FC<IPctChangeIndicatorProps> = ({ oldValue = 0, newValue = 0, upColor, downColor }) => {
    if (!newValue || !oldValue) {
        return null;
    }

    const dir = (newValue > oldValue ? 'up' : newValue < oldValue ? 'down' : 'flat');
    const color = (dir === 'up' ? upColor : dir === 'down' ? downColor : undefined);

    let value;
    if (oldValue !== newValue) {
        value = `${Math.abs(Math.round((1 - newValue/oldValue) * 100)).toLocaleString()}%`;
    } else {
        value = '—';
    }

    return (
        <ChangeIndicator direction={dir} color={color} value={value} />
    );
};
